import React from "react";
import TextField from "@mui/material/TextField";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { colors } from "../assets/colors";

interface InputProps {
  title?: string;
  required?: boolean;
  placeholder?: string;
  value?: string;
  onChange?: (e: any) => void;
  type?: string;
  variant?: "filled" | "outlined" | "standard";
  disabled?: boolean;
  autoComplete?: string;
  style?: React.CSSProperties;
  multiline?: boolean;
  rows?: number;
  endIcon?: React.ReactNode;
  onKeyPress?: (e: any) => void;
  onBlur?: () => void;
  disabledBorders?: boolean;
  onFocus?: () => void;
}

export default function Input(props: InputProps) {
  return (
    <Box sx={{ mt: 2, width: "100%" }}>
      <Typography
        component="span"
        variant="subtitle2"
        sx={{
          flexGrow: 1,
          fontSize: 12,
          fontWeight: "500",
          color: colors.gray,
        }}
      >
        {props.title ? props.title : ""}
      </Typography>
      <TextField
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onKeyPress={props.onKeyPress}
        disabled={props.disabled}
        variant={props.variant ? props.variant : "outlined"}
        required={props.required}
        fullWidth
        multiline={props.multiline}
        rows={props.rows ? props.rows : 1}
        placeholder={props.placeholder}
        value={props.value}
        onChange={(e: any) => props.onChange && props.onChange(e)}
        slotProps={{
          input: {
            endAdornment: props.endIcon ? props.endIcon : null,
            disableUnderline: props.disabledBorders ? true : false,
            style: {
              borderRadius: "8px",
              justifyContent: "center",
              ...props.style,
            },
          },
        }}
        autoComplete={props.autoComplete ? props.autoComplete : "off"}
        type={props.type ? props.type : "text"}
      />
    </Box>
  );
}
